import PropTypes from "prop-types";
import Facet from "features/view/components/Facets/Facet";
import Expandable from "components/ui/Expandable/Expandable";

function FacetGroup({ label, items, expanded = false, hideHeader = false }) {
  let facets = [];
  items.forEach((item, index) => {
    if (!item.values) {
      return;
    }
    facets.push(
      <Facet key={ index }
             label={ item.values.value }
             count={ item.values.count }
             url={ item.url }
             active={ item.values.active === "true" }/>
    );
  });

  return (
    <>
      <Expandable
        label={ label }
        expanded={ expanded }
        hideHeader={ hideHeader }
      >
        { facets }
      </Expandable>
    </>
  );
}

FacetGroup.propTypes = {
  label: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
  expanded: PropTypes.bool,
  hideHeader: PropTypes.bool,
}

export default FacetGroup;
